import "./MobileHistoryTable.css";

import { Dispatch, useEffect } from "react";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HistoryModel } from "../../../../models/fineModels";
import { downloadFile } from "../../../../api/infringement";
import { useState } from "react";

interface MobileHistoryTableProps {
  data: HistoryModel[] | null;
  search: string | null;
}

const MobileHistoryTable = ({ data, search }: MobileHistoryTableProps) => {
  const [fines, setFines] = useState<HistoryModel[] | null>(data);
  const [limit, setLimit] = useState<number>(10);

  useEffect(() => {
    setFines(data);
  }, [data]);

  const onContinueClicked = (account: string) => {
    downloadFile(account);
  };

  const onLoadMoreClicked = () => setLimit(limit + 10);

  useEffect(() => {
    let finesCopy = data;
    if (search && search?.length > 0 && finesCopy) {
      finesCopy = finesCopy?.filter((fine) => {
        const idNo = fine.id_number;
        let accNo = fine?.account_number
          .toLowerCase()
          .replace(/\//g, "")
          .trim();
        let query = search.toLowerCase().replace(/\//g, "").trim();
        return accNo.includes(query) || idNo.toLowerCase().includes(query);
      });
      setFines(finesCopy!);
    } else {
      setFines(data);
    }
  }, [search]);

  return (
    <div className="mobile-history-table-container">
      {fines
        ?.slice(0, limit < fines.length ? limit : fines.length)
        .map((fine: HistoryModel, index: number) => (
          <div
            key={index}
            className="mobile-fine-container"
            onClick={() => {
              onContinueClicked(fine.account_number);
            }}
          >
            <div className="mobile-fine-header">
              <p>{fine.account_number}</p>
              <div className="mobile-fine-header-right">
                <div
                  className="mobile-fine-warrant-status"
                  style={{
                    backgroundColor:
                      fine.warrant_status === "Warrant" ? "#D7D7D7" : "#EEEEEE",
                  }}
                >
                  <p
                    style={{
                      fontSize: 12,
                      fontWeight: "normal",
                      width: "100%",
                    }}
                  >
                    Download
                  </p>
                </div>
              </div>
            </div>
            {fine.id_number ? (
              <div className="mobile-fine-row">
                <p>ID Number</p>
                <p>{fine?.id_number}</p>
              </div>
            ) : null}

            <div className="mobile-fine-row">
              <p>Amount</p>
              <p>R{Number(fine.amount_paid) / 100}</p>
            </div>
            <div className="mobile-fine-row">
              <p>Date Paid</p>
              <p>{fine.date_paid}</p>
            </div>
            <div className="mobile-fine-row">
              <p>Status</p>
              <p>{fine.warrant_status}</p>
            </div>
          </div>
        ))}
      {fines && limit < fines?.length ? (
        <div
          className="load-more-fines-button"
          onClick={() => onLoadMoreClicked()}
        >
          <p>Load More</p>
          <FontAwesomeIcon
            icon={faAngleDown}
            size="1x"
            color="#18283c"
            style={{ marginLeft: 10 }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default MobileHistoryTable;
